import React from "react";
import { EqualIconSmall, TextValueTable1, TextValueTable2 } from "../styles";
import styled from "styled-components";
import { getCoinCodeImage } from "../../../utils/helper";

const Wraper = styled.div`
  border-top: 1px solid #f2efef;
  &:first-child {
    border-top: unset;
  }
`;

export const WalletRowItem = ({
  coin,
  marketPrice,
  amount,
  local,
  onClick,
  SourceCoin,
  className,
}) => {
  return (
    <Wraper
      className={`flex justify-between py-[5px] ${className}`}
      onClick={() => onClick?.()}
    >
      <div className="flex flex-wrap items-center gap-x-3">
        <div>
          <img
            alt=""
            style={{ width: 28, height: 28 }}
            src={`/assets/images/otc/crypto/${getCoinCodeImage(
              coin
            )?.toLowerCase()}.svg`}
          />
        </div>
        <div>
          <div className="flex">
            <TextValueTable1>{coin}</TextValueTable1>
            {SourceCoin}
          </div>
          {/* <TextValueTable2 className="mt-[4px]">{marketPrice}</TextValueTable2> */}
        </div>
      </div>
      <div className="ml-[12px]">
        <TextValueTable1 className="text-right">{amount}</TextValueTable1>
        <TextValueTable2 className="text-right mt-[4px] flex items-center w-full justify-end gap-2">
          <EqualIconSmall />
          {local}
        </TextValueTable2>
      </div>
    </Wraper>
  );
};

export const WalletRowItemHome = ({
  coin,
  marketPrice,
  amount,
  local,
  onClick,
  SourceCoin,
}) => {
  return (
    <Wraper
      className="flex justify-between py-[8px]"
      onClick={() => onClick?.()}
    >
      <div className="flex items-center">
        <div>
          <img
            alt=""
            style={{ width: 28, height: 28 }}
            src={`/assets/images/otc/crypto/${getCoinCodeImage(coin)?.toLowerCase()}.svg`}
          />
        </div>
        <div className="ml-[12px]">
          <div className="flex-col">
            <TextValueTable1>{coin}</TextValueTable1>
            {SourceCoin}
          </div>
          {/* <TextValueTable2 className="mt-[4px]">{marketPrice}</TextValueTable2> */}
        </div>
      </div>
      <div className="ml-[12px]">
        <TextValueTable1 className="text-right">{amount}</TextValueTable1>
        <TextValueTable2 className="text-right mt-[4px] flex items-center gap-2">
          <EqualIconSmall />
          {local}
        </TextValueTable2>
      </div>
    </Wraper>
  );
};
